export default {
  isLoading: {},
  data: {},
};
